module.exports = __webpack_public_path__ + "img/jquery-ui-logo.323d062d.png";